import { render, staticRenderFns } from "./MarketingAssets.vue?vue&type=template&id=39a1a7c0&scoped=true&"
import script from "./MarketingAssets.vue?vue&type=script&lang=js&"
export * from "./MarketingAssets.vue?vue&type=script&lang=js&"
import style0 from "./MarketingAssets.vue?vue&type=style&index=0&id=39a1a7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1a7c0",
  null
  
)

export default component.exports